<template>
    <li class="relative">
        <!-- Tray Link -->
        <button
            @click="($event) => openTray(tray)"
            class="border border-keyline-primary bg-gray-120 dark:bg-gray-700 flex gap-4 items-center leading-none max-w-full rounded-md text-v2-gray-20 text-left w-full hover:border-v2-gray-70 dark:border-v2-gray-10 dark:text-v2-gray-130 hover:dark:border-v2-gray-90 hover:dark:text-v2-white"
        >
            <!-- Icon / Image Slot -->
            <span
                aria-hidden="true"
                class="flex items-center justify-center shrink-0 size-[60px] border-r border-keyline-primary"
            >
                <BaseSvg
                    v-if="tray.name === 'Favorites'"
                    name="HeartOutlineThick"
                    class="fill-tertiary size-6 "
                />
                <span
                    v-else-if="tray.isNew"
                    class="font-medium text-[12px] text-v2-gray-20 uppercase dark:text-v2-gray-90"
                >
              New
            </span>
            <BaseSvg v-else name="icon-pin-tray-thick" class="size-6 fill-tertiary" />
          </span>

            <!-- Tray Info -->
            <span class="grid grid-cols-5 items-baseline overflow-hidden mr-16 w-full">
                <span class="leading-none font-medium text-v2-gray-20 dark:text-v2-gray-130 max-w-[90%] truncate whitespace-nowrap col-span-4" :title="tray.name">
                    {{ tray.name }}
                </span>
                <span class="leading-none text-xs text-v2-gray-90 col-span-1">
                    {{ tray.pin_count }} {{ useHelpers().pluralize(tray.pin_count, 'pin','pins') }}
                </span>
            <!-- <span
                v-if="tray.description"
                aria-hidden="true"
                class="text-sm type-tertiary truncate"
            >
                {{ tray.description }}
            </span> -->
          </span>
        </button>

        <!-- More Button -->
        <div class="absolute right-2 top-3.5">
            <MoreButton :tray="tray" />
        </div>


        <!-- Confirmation Badge -->
        <span
            :class="['confirmation-ready !top-3/4', { 'confirmation-run': isConfirmRun }]"
            aria-hidden="true"
        >
          <BaseSvg name="Check" aria-hidden="true" class="size-4"/>
          Added
        </span>
    </li>
</template>

<script setup lang="ts">
import {ref, watch, defineProps} from 'vue';
import {BaseSvg, MoreButton} from '@/Components';
import {usePinsDrawer, useHelpers} from '@/Composables';

const props = defineProps(['tray',]);


// Reactive state
const isConfirmRun = ref(false)
const {openTray} = usePinsDrawer();

const emit = defineEmits(['select-tray']);

// Watch confirmation-run trigger
watch(
    () => props.tray,
    () => {
        // For example, run confirmation when new tray created
        isConfirmRun.value = !!props.tray.isNew
        setTimeout(() => (isConfirmRun.value = false), 2000)
    },
    {immediate: true}
)
</script>
